// @flow
import FontFaceObserver from 'fontfaceobserver'
import { memoize } from 'lodash'
import logger from 'loglevel'

const memoizedIsFontLoaded = memoize(isFontLoaded)
const memoizedIsFontForElementLoaded = memoize(isFontForElementLoaded)

export {
  memoizedIsFontLoaded as isFontLoaded,
  memoizedIsFontForElementLoaded as isFontForElementLoaded,
}

/**
 * A wrapper around the FontFaceObserver API (so we can memoize it, because it does some fancy DOM API stuff)
 * Also, the FontFaceObserver is confusing and looks like it's going to do the font loading based on the `load`
 * function name, but it's just checking whether the font has loaded...
 * @param fontFamily - the font family to ensure is loaded
 * @param options - the options object passed to the FontFaceObserver constructor
 * @return a promise that resolves if the font loaded successfully, or rejects if it does not (default timeout is 3
 * seconds)
 */
function isFontLoaded(fontFamily: string, options: Object): Promise<void> {
  return new FontFaceObserver(fontFamily, options).load().catch(err => {
    logger.warn('Could not load PayPal font')
    throw err
  })
}

/**
 * Gets the fontFamily from the computedStyle of the given element to pass along to isFontLoaded
 */
function isFontForElementLoaded(element, options: Object): Promise<void> {
  const { fontFamily = 'PayPal-Sans-Big' } = window.getComputedStyle(
    element,
    null
  )
  const firstFontFamily = fontFamily.split(',')[0].trim()
  return memoizedIsFontLoaded(firstFontFamily, options)
}
